import BaseEntity from "./base.entity";
import uuid from "uuid";

export default class Variation extends BaseEntity {
  defaultParams() {
    return {
      uuid: uuid(),
      name: "",
      variation_options: [],
      deleted: false
    };
  }

  identifier() {
    return this.name || "Variação não identificada";
  }
}



// WEBPACK FOOTER //
// ./src/core/entity/variation.entity.js